module.exports = __webpack_public_path__ + "media/customizations/svlaliving/logo-26c16dc67c3dcddccc53171e6d802b7e.png";